export const VIRTUAL_PRESET_ID = '__virtual__';
